import $ from "jquery";
window.$ = $;
window.jQuery = $;

export function enableAnchorScroll({
    selector = "a[href^='#']",
    elFixedHeight = window.elFixedHeight || 0,
    stepSpace = window.stepSpace || 0,
    duration = 800,
    activeClass = "active",
} = {}) {

    function setActiveAnchor(scrollOverride = null) {
        const anchors = $(selector);
        let found = null;
        const scroll = scrollOverride ?? $(window).scrollTop();
        const hasActiveScroll = $(".jsActiveAnchorScroll").length > 0;
        const offset = hasActiveScroll ? 0 : 100;
        const pixelBuffer = 5;
        anchors.each(function (index) {
            const href = $(this).attr("href");
            const hash = new URL(href, location.origin).hash;
            if (!hash || !$(hash).length) return;
            const top = $(hash).offset().top - elFixedHeight - stepSpace - pixelBuffer;
            const nextAnchor = anchors.eq(index + 1);
            const nextHref = nextAnchor.attr("href");
            const nextHash = new URL(nextHref, location.origin).hash;
            const nextTop =
                nextHash && $(nextHash).length
                    ? $(nextHash).offset().top - elFixedHeight - stepSpace - pixelBuffer
                    : Infinity;

            if (scroll >= top - offset && scroll < nextTop - offset) {
                found = hash;
                return false;
            }
        });
        anchors.removeClass(activeClass);
        if (found) {
            anchors.filter(function () {
                return this.hash === found;
            }).addClass(activeClass);
        }
    }

    function scrollToAnchor(hash, customDuration) {
        if (
            hash &&
            hash !== "#" &&
            $(hash).length &&
            !$(hash).closest(".tab").length
        ) {
            const hasActiveScroll = $(".jsActiveAnchorScroll").length > 0;
            const offTop = $(hash).offset().top - elFixedHeight - (hasActiveScroll?  (innerWidth <= 992 ? innerWidth <= 768 ? 103 : 123 : 76) : stepSpace);
            $("html, body")
                .stop()
                .animate(
                    { scrollTop: offTop },
                    customDuration || duration,
                    () => {
                        setActiveAnchor(offTop);
                    }
                );
        }
    }

    $(document).on("click", selector, function (e) {
        const href = $(this).attr("href");
        if (!href) return;
        const targetUrl = new URL(href, location.origin);
        if (targetUrl.pathname !== location.pathname) {
            return;
        }
        if (targetUrl.hash) {
            e.preventDefault();
            scrollToAnchor(targetUrl.hash);
        }
    });

    $(window).on("scroll", () => setActiveAnchor());

    return { scrollToAnchor, setActiveAnchor };
}
